import {memo, useEffect, useRef, useState} from "react";
import PlayerCard from "../playerCard/playerCard";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import useIntersect from "../../../../../helpers/hooks/useIntersect";
import { conditions } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import { setPlayListCardPopover } from "../../../../../redux/slices/popoversSlice";
import { handleClickRecommendationCard } from "../../../../../redux/actions/videoData.actions";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const PlayListCard = dynamic(() => import("../playList/playListCard"));

const RecommendationList = () => {

    const { recommendationList } = useAppSelector(({ videoData: { recommendationList, isComplexDesktop, isComplexPortrait } }) => ({ recommendationList, isComplexDesktop, isComplexPortrait }), shallowEqual);

    const list = useRef<any>([]);
    const [scrollEnd, setScrollEnd] = useState(false);
    const [listScrolled, setListScrolled] = useState<any>([]);
    const [playListCardInfo, setPlayListCardInfo] = useState<any>(null);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (scrollEnd) {
            if (list.current && listScrolled.length) {
                const moreData = list.current.slice(listScrolled.length + 1, (listScrolled.length + 10) + 1);
                setListScrolled([...listScrolled, ...moreData]);
            }
            setScrollEnd(false);
        }
    }, [scrollEnd]);

    useEffect(() => {
        list.current = recommendationList;
        setListScrolled(list.current.slice(0, 10))
    }, [recommendationList]);


    const handleIntersect = ([entry]: IntersectionObserverEntry[]) => {
        if (entry.isIntersecting) {
            setScrollEnd(true);
        }
    };

    const observerRef = useIntersect(handleIntersect);

    return (
        <div className={`pl-flex pl-flex-col pl-gap-2 ${conditions(ConditionName.isComplexPortrait) && `pl-mb-[300px] pl-mx-3`}`}>
            <p className="pl-text-[14px] pl-font-bold">ویدیوهای پیشنهادی</p>
            {listScrolled.map((item: any,index:number) => (
                <div
                    key={index} 
                    id={`recommendationList-${item.id}`}
                    className={`pl-relative pl-overflow-hidden`}
                    style={{ height: conditions(ConditionName.isComplexDesktop) ? 98 : 80 }}
                >
                    <PlayerCard
                        content_type={item.content_type}
                        id={item.id}
                        tags={item.tag}
                        src={item.banner} 
                        type={item.type!}
                        status_text={item.status_text} 
                        isVideo={false}
                        width={conditions(ConditionName.isComplexDesktop) ? 174 : (conditions(ConditionName.isComplexPortrait) ? 142 : window.innerWidth)}
                        height={conditions(ConditionName.isComplexDesktop) ? 98 : (conditions(ConditionName.isComplexPortrait) ? 80 : (window.innerWidth * 9) / 16)}
                        duration={item.duration} 
                        title={item.title}
                        isComplexDesktop={conditions(ConditionName.isComplexDesktop)} 
                        viewers={item.viewers}
                        imdb_rate={item.imdb_rate}
                        date={((item.type === "playlist" && item.content_type === 1) || (item.type === "vod" && (item.content_type === 1 || item.content_type === 0) )) ? item.release_year : item.start_time}
                        onClick={(event: any) => {
                            if(item.type === "playlist") {
                                dispatch(setPlayListCardPopover(true));
                                setPlayListCardInfo(item);
                            } else handleClickRecommendationCard(event, item.id, item.user_id, item.type, index + 1);
                        }}
                        commentsCount={item.comments_count}
                        star={item.star}
                    />
                </div>
                
            ))}
            <div id="observer" className="pl-bg-transparent pt-5" ref={observerRef}/>
            {playListCardInfo && <PlayListCard playListCardInfo={playListCardInfo} />}
        </div>
    )
}

export default memo(RecommendationList);